
'use client'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import './styles.css';

import { Button, DatePicker, Form, Input, InputNumber, Select, Table, TableColumnsType, TableProps, Tooltip, Typography, Upload, UploadProps } from "antd"
import { PleaScheduleModel } from '../../../../../Models/PleaScheduleModel';

const monthNames = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
];

export default function PLeaScheduleTable ({ items, operationDelete, setItemEdit }: 
    { items: PleaScheduleModel[], operationDelete: (id: string) => Promise<void>, setItemEdit: (values: PleaScheduleModel) => void }) {

   

    const handleChartType = (startDate: Date, endDate: Date, title: number) =>{
        const start = startDate.getMonth() + 1;
        const end = endDate.getMonth() + 1;

        if(start == title && end != title){
            return (
                <Tooltip placement="topLeft" title={`${monthNames[title-1]}`} >
                    <div 
                        style={{
                            width: '100%',
                            height: '10px',
                            backgroundColor: '#6DC8EC', 
                            borderTopLeftRadius: '8px',
                            borderBottomLeftRadius: '8px',
                            marginLeft: '50%',
                        }}>
                </div>
                </Tooltip>

            );
        }
        else if(start == title && end == title){
            return (
                <Tooltip placement="top" title={`${monthNames[title-1]}`} >
                    <div 
                        style={{
                            width: '20%',
                            height: '10px',
                            backgroundColor: '#6DC8EC', 
                            borderRadius: '8px',
                            marginLeft: '40%',
                        }}>
                        
                    </div>
                </Tooltip>
            );
        }
        else if(end == title){
            return (
                <Tooltip placement="topRight" title={`${monthNames[title-1]}`} >
                    <div 
                        style={{
                            width: '60%',
                            height: '10px',
                            backgroundColor: '#6DC8EC', 
                            borderTopRightRadius: '8px',
                            borderBottomRightRadius: '8px',
                        }}>
                    </div>
                </Tooltip>
            );
        }
        else if(start < title && end > title){
            return (
                <Tooltip placement="top" title={`${monthNames[title-1]}`} >
                    <div 
                        style={{
                            width: '100%',
                            height: '10px',
                            backgroundColor: '#6DC8EC', 
                        }}>
                        
                    </div>
                </Tooltip>
            );
        }
        else{
            return (
                <div ></div>
            );
        }

    };

    const props: TableColumnsType = [
        {
            title: 'Meta e Atividades',
            dataIndex: 'name',
            width: '25%',
            align: 'center',
            showSorterTooltip: { target: 'full-header' },
            sorter: (a, b) => a.name.localeCompare(b.name),
            sortDirections: ['ascend', 'descend'],
            filters: Array.from(
                new Set(items.map((item) => item.name)) 
            ).map((name) => ({
                text: name,
                value: name,
            })),
            onFilter: (value, record) => record.name === value,
            render: (value) => {
                return <div>
                        <Tooltip placement="topLeft" title={value}>
                            <Typography.Text className='column-name'>{value}</Typography.Text>
                        </Tooltip>
                </div>
            },
        },
        {
            title: 'Início',
            dataIndex: 'startDate',
            width: '8%',
            align: 'center',
            sorter: (a, b) => a.startDate.localeCompare(b.startDate),
            sortDirections: ['ascend', 'descend'],
            filters: Array.from(
                new Set(
                    items.map((item) => new Date(item.startDate).getMonth())
                )
            )
            .sort((a, b) => a - b)
            .map((month) => ({
                text: monthNames[month], 
                value: month,
            })),
            onFilter: (value, record) =>
                new Date(record.startDate).getMonth() === value,
            render: (value) => {
                return <div>
                    <Typography.Text className='column-name'>{new Date(value).toLocaleDateString()}</Typography.Text>
                </div> 
            },
        },
        {
            title: 'Fim',
            dataIndex: 'endDate',            
            width: '8%',            
            align: 'center',
            sorter: (a, b) => a.endDate.localeCompare(b.endDate),
            sortDirections: ['ascend', 'descend'],
            filters: Array.from(
                new Set(
                    items.map((item) => new Date(item.endDate).getMonth())
                )
            )
            .sort((a, b) => a - b)
            .map((month) => ({
                text: monthNames[month], 
                value: month,
            })),
            onFilter: (value, record) =>
                new Date(record.endDate).getMonth() === value,
            render: (value) => {
                return <div>
                    <Typography.Text className='column-name'>{new Date(value).toLocaleDateString()}</Typography.Text>
                </div> 
            },
        },
        {
            title: 'Duração',
            dataIndex: 'duration',
            width: '8%',            
            align: 'center',
            sorter: (a, b) => a.duration - b.duration,
            sortDirections: ['ascend', 'descend'],
            filters: Array.from(
                new Set(items.map((item) => item.duration)) 
            ).map((duration) => ({
                text: duration.toString(),
                value: duration,
            })),
            onFilter: (value, record) => record.duration === value,
            render: (value) => {
                return <div>
                    <Typography.Text className='column-name'>{value}</Typography.Text>
                </div>
            },
        },
        {
            title: 'Ações',
            dataIndex: 'actions',
            align: 'center',
            render: (value, record) => {
                return <div className='column-action'>

                    <EditOutlined  className='icon-edit' onClick={() => setItemEdit(record as PleaScheduleModel)}/>
                    <DeleteOutlined  className='icon-delete' onClick={() => operationDelete(record.id)} />

                </div>
            },
            width: '5%',
        },
        {
            title: 'Meses',
            dataIndex: 'duration',
            className: 'hide-header', 
            width: '45%',  
            children: [
                {
                    title: '1',
                    align: 'center',
                    className: 'column-month',
                    width: '3%',
                    render: (record) => {
                        return (
                            <div>
                                {handleChartType(new Date(record.startDate), new Date(record.endDate), parseInt('1'))}
                            </div>
                        );
                    },
                },
                {
                    title: '2',
                    align: 'center',
                    width: '3%',
                    className: 'column-month',
                    render: (record) => {
                        return (
                            <div>
                                {handleChartType(new Date(record.startDate), new Date(record.endDate), parseInt('2'))}
                            </div>
                        );
                    },
                },                
                {
                    title: '3',
                    align: 'center',
                    width: '3%',
                    className: 'column-month',
                    render: (record) => {
                        return (
                            <div>
                                {handleChartType(new Date(record.startDate), new Date(record.endDate), parseInt('3'))}
                            </div>
                        );
                    },
                },                
                {
                    title: '4',
                    align: 'center',
                    width: '3%',
                    className: 'column-month',
                    render: (record) => {
                        return (
                            <div>
                                {handleChartType(new Date(record.startDate), new Date(record.endDate), parseInt('4'))}
                            </div>
                        );
                    },
                },                
                {
                    title: '5',
                    align: 'center',
                    width: '3%',
                    className: 'column-month',
                    render: (record) => {
                        return (
                            <div>
                                {handleChartType(new Date(record.startDate), new Date(record.endDate), parseInt('5'))}
                            </div>
                        );
                    },
                },                
                {
                    title: '6',
                    align: 'center',
                    width: '3%',
                    className: 'column-month',
                    render: (record) => {
                        return (
                            <div>
                                {handleChartType(new Date(record.startDate), new Date(record.endDate), parseInt('6'))}
                            </div>
                        );
                    },
                },                
                {
                    title: '7',
                    align: 'center',
                    width: '3%',
                    className: 'column-month',
                    render: (record) => {
                        return (
                            <div>
                                {handleChartType(new Date(record.startDate), new Date(record.endDate), parseInt('7'))}
                            </div>
                        );
                    },
                },                
                {
                    title: '8',
                    align: 'center',
                    width: '3%',
                    className: 'column-month',
                    render: (record) => {
                        return (
                            <div>
                                {handleChartType(new Date(record.startDate), new Date(record.endDate), parseInt('8'))}
                            </div>
                        );
                    },
                },                
                {
                    title: '9',
                    align: 'center',
                    width: '3%',
                    className: 'column-month',
                    render: (record) => {
                        return (
                            <div>
                                {handleChartType(new Date(record.startDate), new Date(record.endDate), parseInt('9'))}
                            </div>
                        );
                    },
                },                
                {
                    title: '10',
                    align: 'center',
                    width: '3%',
                    className: 'column-month',
                    render: (record) => {
                        return (
                            <div>
                                {handleChartType(new Date(record.startDate), new Date(record.endDate), parseInt('10'))}
                            </div>
                        );
                    },
                },                
                {
                    title: '11',
                    align: 'center',
                    width: '3%',
                    className: 'column-month',
                    render: (record) => {
                        return (
                            <div>
                                {handleChartType(new Date(record.startDate), new Date(record.endDate), parseInt('11'))}
                            </div>
                        );
                    },
                },
                {
                    title: '12',
                    align: 'center',
                    width: '3%',
                    className: 'column-month',
                    render: (record) => {
                        return (
                            <div>
                                {handleChartType(new Date(record.startDate), new Date(record.endDate), parseInt('12'))}
                            </div>
                        );
                    },
                },
            ]
        },
    ];

    return (
        <div className= 'div-main' >

                <Table
                    className='table'
                    columns={props}
                    dataSource={items}
                    showSorterTooltip={{ target: 'sorter-icon' }}
                    pagination={{
                        pageSizeOptions: [7, 10, 20, 30],
                        defaultPageSize: 20,
                    }}
                />
        </div>

    )
}